import { CheckOutProductPage } from '@/pages/checkout-product';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/checkout-product')({
	component: CheckOutProductPage,
});
